import { app } from '../../../../../../app';
import { Controller } from './add-users-to-labels.controller';

app.component('companyUserLabelMembersAdd', {
    bindings: {
        users: '<',
        companyId: '<',
        labels: '<'
    },
    controller: Controller,
    templateUrl: require('./add-users-to-labels.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.component.js